import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    salesChannelId: '3ff74d5b-2386-4958-a14f-c70a945e7db1',
    countryCodes: ['RO'],
    locale: 'ro-RO',
    enable: {
        prelaunch: false,
    },
});
